import { Box, Button, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';
import { useRuntimeAwareAuth } from '~/hooks/useRuntimeAwareAuth/useRuntimeAwareAuth';

import { Logo } from './components/Logo/Logo';

// Design decision on sizes
const leftSpaceWidth = '560px';
const contentWidth = '328px';

export const Login = () => {
  const { signinRedirect } = useRuntimeAwareAuth();
  const { t } = useTranslation(I18nNamespace.common, { keyPrefix: 'Login' });

  return (
    <Stack
      direction="row"
      sx={{
        flex: '1',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          maxWidth: leftSpaceWidth,
          minWidth: leftSpaceWidth,
          width: leftSpaceWidth,
        }}
      >
        <Stack
          direction="column"
          spacing={4}
          sx={{
            width: contentWidth,
          }}
        >
          <Stack direction="column" spacing={2}>
            <Typography variant="h6">{t('title')}</Typography>
            <Typography variant="body1" color="textSecondary">
              {t('description')}
            </Typography>
          </Stack>
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={() => {
              signinRedirect();
            }}
          >
            {t('button')}
          </Button>
        </Stack>
      </Box>
      <Logo />
    </Stack>
  );
};
